/**
 * @typedef {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} Field
 */
/**
 * Enabled/disables fields
 *
 * Making field (input) disabled prevents it from being added to final form submission
 * @param {Field|NodeListOf<Field>} field
 * @param {boolean|null} force
 */
function toggleFieldVisibility(field, force = null) {
	if (!field) {
		console.log('No field');
		return;
	}
	const fields = Array.from(field instanceof NodeList ? field : [field]);

	for (const fieldElement of fields) {
		const shouldAppear = typeof force === 'boolean' ? force : !fieldElement.disabled;

		fieldElement.disabled = !shouldAppear;
		fieldElement.classList.toggle('input--inactive', !shouldAppear);
	}
}

function hideField(field) {
	toggleFieldVisibility(field, false)
}

function showField(field) {
	toggleFieldVisibility(field, true)
}
